/* Third party libraries */
import axios from 'axios';
import type { WidgetDataInterface } from '@/components/Widgets/types';

import type { TDMAnalytics } from '../types/Analytics';
import { baseUrl, HttpMethods } from './base';

// Generated by https://quicktype.io

const analyticsBasePath = `${baseUrl.SHERPA}/analytics`;

export interface GetTdmAnalyticsResponse {
  data: Data;
}

export interface Data {
  tasks: TDMAnalytics[];
  deliverables: TDMAnalytics[];
  milestones: TDMAnalytics[];
}

export async function getUserTdmAnalytics(userId: number) {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm?user_id=${userId}&projects_archived=false`);
  return resp.data.data;
}

export async function getCompanyTdmAnalytics() {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm?projects_archived=false`);
  return resp.data.data;
}

export async function getProjectTdmAnalytics(projectId: number) {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm?project_id=${projectId}`);
  return resp.data.data;
}

export interface GetTdmAnalyticsParams {
  user_id?: number;
  project_id?: number;
  phase?: string;
  projects_archived?: string;
}

export async function getTdmAnalytics(params: GetTdmAnalyticsParams) {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm`, { params });
  return resp.data.data;
}

export interface GetCompanyProjectsAnalyticsParams {
  params?: { [key: string]: string };
}

export async function getProjectsAnalytics({ params }: GetCompanyProjectsAnalyticsParams) {
  const res = await axios({
    method: HttpMethods.GET,
    url: `${analyticsBasePath}/dashboard`,
    params,
  });

  return res.data;
}

export async function getWidgetsList() {
  const res = await axios.request({
    method: 'GET',
    url: `${baseUrl.SHERPA}/widgets`,
  });
  return res.data;
}

/* Widget Interface  */

export interface WidgetList {
  widgetId: number;
  locationId: number;
}

export interface PostWidgetsListInterface {
  widgets: WidgetList[];
  dashboardType: string;
}

export async function postWidgetsList(props: PostWidgetsListInterface) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/widgets`,
    data: props,
  });
  return res.data;
}

export interface GetDashboardDataResponse extends WidgetDataInterface {
  data: any[];
}

export async function getDashboardData(dashboardType: string) {
  const _res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/widgets/data?dashboardType=${dashboardType}`,
  });
  return {
    data: [
      {
        slug: 'TOTAL_PROJECTS',
        name: 'Total Projects',
        description: 'Total Projects',
        data: 7,
      },
      {
        slug: 'PROJECT_LOCATION',
        name: 'Project Location',
        description: 'Project Location',
        data: [
          {
            id: 634,
            name: '4th & WI',
            address: '401 West Wisconsin Avenue',
            city: 'Milwaukee',
            state: 'Wisconsin',
            zipCode: '53203',
            budget: [
              {
                name: 'CDBG Funds',
                amount: 2000000,
              },
              {
                name: 'Tax Credit Equity-NMTC',
                amount: 5000000,
              },
            ],
            sources: [
              {
                name: 'CDBG Funds',
                amount: 2000000,
              },
              {
                name: 'Tax Credit Equity-NMTC',
                amount: 5000000,
              },
            ],
            uses: [
              {
                name: 'Acquisition',
                amount: 200000,
                source: 'CDBG Funds',
              },
              {
                name: 'Market Study',
                amount: 150000,
                source: 'CDBG Funds',
              },
              {
                name: 'Permitting',
                amount: 50000,
                source: 'CDBG Funds',
              },
            ],
            squareFeet: 575000,
            location: {
              lat: 43.03874,
              lng: -87.91675029999999,
              city: 'Milwaukee',
              state: 'Wisconsin',
              country: 'United States of America',
              placeId: 'ChIJUQDJMZ4ZBYgRNq3t4gUOmVM',
              address1: '401 West Wisconsin Avenue',
              postalCode: '53203',
            },
            lead: {
              id: 312,
              name: 'Russell Stamper II',
              email: 'aah+wisconsin@sein.tech',
              profileImageUrl: '',
            },
          },
          {
            id: 637,
            name: 'NIP-4212 Highland',
            address: '4212 W Highland Blvd',
            city: 'Milwaukee',
            state: 'Wisconsin',
            zipCode: '53208',
            budget: [
              {
                name: 'CDBG Funds',
                amount: 30000,
              },
            ],
            sources: [
              {
                name: 'HOME Funds',
                amount: 30000,
              },
            ],
            uses: [
              {
                name: 'Specialty Construction-Plumbing',
                amount: 10000,
                source: 'HOME Funds',
              },
              {
                name: 'Specialty Construction-Electrical',
                amount: 10000,
                source: 'HOME Funds',
              },
              {
                name: 'Specialty Construction-Window Replacement',
                amount: 10000,
                source: 'HOME Funds',
              },
            ],
            squareFeet: 1500,
            location: {
              lat: 43.0466592,
              lng: -87.9638026,
              city: 'Milwaukee',
              state: 'Wisconsin',
              country: 'United States of America',
              placeId: 'ChIJBX_zFa4bBYgRuz6r4mye3C0',
              address1: '4212 W Highland Blvd',
              postalCode: '53208',
            },
            lead: {
              id: 312,
              name: 'Russell Stamper II',
              email: 'aah+wisconsin@sein.tech',
              profileImageUrl: '',
            },
          },
          {
            id: 638,
            name: 'SFH',
            address: '3233 West North Avenue',
            city: 'Milwaukee',
            state: 'Wisconsin',
            zipCode: '53208',
            budget: [
              {
                name: 'CDBG Funds',
                amount: 1000000,
              },
            ],
            sources: [
              {
                name: 'CDBG Funds',
                amount: 1000000,
              },
            ],
            uses: [
              {
                name: 'Acquisition',
                amount: 250000,
                source: 'CDBG Funds',
              },
              {
                name: 'Architect',
                amount: 100000,
                source: 'CDBG Funds',
              },
              {
                name: 'Construction-Demolition',
                amount: 50000,
                source: 'CDBG Funds',
              },
              {
                name: 'Construction-Hard Costs',
                amount: 600000,
                source: 'CDBG Funds',
              },
            ],
            squareFeet: 5000,
            location: {
              lat: 43.06047119999999,
              lng: -87.9549195,
              city: 'Milwaukee',
              state: 'Wisconsin',
              country: 'United States of America',
              placeId: 'ChIJ08r9bZUbBYgRwAnrxzBh784',
              address1: '3233 West North Avenue',
              postalCode: '53208',
            },
            lead: {
              id: 312,
              name: 'Russell Stamper II',
              email: 'aah+wisconsin@sein.tech',
              profileImageUrl: '',
            },
          },
          {
            id: 652,
            name: 'New Project',
            address: '515 North Jefferson Street',
            city: 'Milwaukee',
            state: 'Wisconsin',
            zipCode: '53202',
            budget: [],
            sources: [
              {
                name: 'Debt-Bank',
                amount: 300000,
              },
              {
                name: 'CDBG Funds',
                amount: 150000,
              },
            ],
            uses: [
              {
                name: 'Acquisition',
                amount: 125000,
                source: 'Debt-Bank',
              },
              {
                name: 'Legal',
                amount: 50000,
                source: 'CDBG Funds',
              },
            ],
            squareFeet: 543453,
            location: {
              lat: 43.0367852,
              lng: -87.9054087,
              city: 'Milwaukee',
              state: 'Wisconsin',
              country: 'United States of America',
              placeId: 'ChIJCejPSqYZBYgRF7L1RVvZiXQ',
              address1: '515 North Jefferson Street',
              postalCode: '53202',
            },
            lead: {
              id: 325,
              name: 'Alice Kennedy',
              email: 'aah+govdemo1@sein.tech',
              profileImageUrl: '',
            },
          },
          {
            id: 635,
            name: 'Marcus Center Garage',
            address: '1001 North Water Street',
            city: 'Milwaukee',
            state: 'Wisconsin',
            zipCode: '53202',
            budget: [],
            sources: [
              {
                name: 'ARPA Funds',
                amount: 5000000,
              },
              {
                name: 'CDBG Funds',
                amount: 2000000,
              },
              {
                name: 'Tax Credit Equity-NMTC',
                amount: 8000000,
              },
            ],
            uses: [
              {
                name: 'Construction-Site Work',
                amount: 1000000,
                source: 'ARPA Funds',
              },
              {
                name: 'Construction-Demolition',
                amount: 2500000,
                source: 'CDBG Funds',
              },
              {
                name: 'Architect',
                amount: 900000,
                source: 'Tax Credit Equity-NMTC',
              },
              {
                name: 'Civil Engineer',
                amount: 500000,
                source: 'CDBG Funds',
              },
              {
                name: 'Construction-Hard Costs',
                amount: 5000000,
                source: 'Tax Credit Equity-NMTC',
              },
            ],
            squareFeet: 120000,
            location: {
              lat: 43.0439036,
              lng: -87.9117212,
              city: 'Milwaukee',
              state: 'Wisconsin',
              country: 'United States of America',
              placeId: 'ChIJEb2WfgsZBYgRApLZWMmllh8',
              address1: '1001 North Water Street',
              postalCode: '53202',
            },
            lead: {
              id: 312,
              name: 'Russell Stamper II',
              email: 'aah+wisconsin@sein.tech',
              profileImageUrl: '',
            },
          },
          {
            id: 636,
            name: 'NIP-384 Smith St',
            address: '5220 West Vliet Street',
            city: 'Milwaukee',
            state: 'Wisconsin',
            zipCode: '53208',
            budget: [
              {
                name: 'CDBG Funds',
                amount: 30000,
              },
            ],
            sources: [
              {
                name: 'CDBG Funds',
                amount: 30000,
              },
            ],
            uses: [
              {
                name: 'Specialty Construction-Roof',
                amount: 12000,
                source: 'CDBG Funds',
              },
              {
                name: 'Specialty Construction-HVAC',
                amount: 18000,
                source: 'CDBG Funds',
              },
            ],
            squareFeet: 1500,
            location: {
              lat: 43.0494366,
              lng: -87.9795159,
              city: 'Milwaukee',
              state: 'Wisconsin',
              country: 'United States of America',
              placeId:
                'Eik1MjIwIFcgVmxpZXQgU3QsIE1pbHdhdWtlZSwgV0kgNTMyMDgsIFVTQSIxEi8KFAoSCRHqf70FGwWIESgGiZ1l-RPpEOQoKhQKEgnv43x6yBsFiBGlgdtbdZTwbg',
              address1: '5220 West Vliet Street',
              postalCode: '53208',
            },
            lead: {
              id: 312,
              name: 'Russell Stamper II',
              email: 'aah+wisconsin@sein.tech',
              profileImageUrl: '',
            },
          },
          {
            id: 672,
            name: 'Test',
            address: '1308 West Lombard Street',
            city: 'Baltimore',
            state: 'Maryland',
            zipCode: '21223',
            budget: [],
            sources: [],
            uses: [],
            squareFeet: 2500,
            location: {
              lat: 39.2867349,
              lng: -76.6384171,
              city: 'Baltimore',
              state: 'Maryland',
              country: 'United States of America',
              placeId: 'ChIJ99-EilQDyIkRwj6vwxfeVEk',
              address1: '1308 West Lombard Street',
              postalCode: '21223',
            },
            lead: {
              id: 312,
              name: 'Russell Stamper II',
              email: 'aah+wisconsin@sein.tech',
              profileImageUrl: '',
            },
          },
        ],
      },
      {
        slug: 'PROJECT_STATUS_SUMMARY',
        name: 'Project Status Summary',
        description: 'Project Status Summary',
        data: [
          {
            _count: 1,
            status: 'IN_DESIGN_DEVELOPMENT_DESIGN',
          },
          {
            _count: 3,
            status: 'INVENTORY',
          },
          {
            _count: 1,
            status: 'MEP_INSTALL',
          },
          {
            _count: 1,
            status: 'OUT_TO_RFP',
          },
          {
            _count: 1,
            status: 'PERMITTING_BUILDING_PERMIT',
          },
          {
            status: 'AWARDED',
            _count: 0,
          },
          {
            status: 'IN_DESIGN_CONCEPTUAL',
            _count: 0,
          },
          {
            status: 'IN_DESIGN_SCHEMATIC_DESIGN',
            _count: 0,
          },
          {
            status: 'IN_DESIGN_CONSTRUCTION_DOCUMENTS',
            _count: 0,
          },
          {
            status: 'ENTITLEMENT_RE_ZONE',
            _count: 0,
          },
          {
            status: 'ENTITLEMENT_VARIANCE_REQUEST',
            _count: 0,
          },
          {
            status: 'PERMITTING_SITE_PLAN_Approval',
            _count: 0,
          },
          {
            status: 'PERMITTING_LAND_DISTURBANCE_PERMIT',
            _count: 0,
          },
          {
            status: 'ON_HOLD',
            _count: 0,
          },
          {
            status: 'COMMUNITY_FEEDBACK',
            _count: 0,
          },
          {
            status: 'WORKING_TO_CLOSE_PROPERTY',
            _count: 0,
          },
          {
            status: 'WORKING_TO_CLOSE_FINANCING',
            _count: 0,
          },
          {
            status: 'WORKING_ON_LOI_PSA',
            _count: 0,
          },
          {
            status: 'ENVIRONMENTAL_FEASIBILITY_PHASE_1_ENVIRONMENTAL',
            _count: 0,
          },
          {
            status: 'ENVIRONMENTAL_FEASIBILITY_GEO_TECH',
            _count: 0,
          },
          {
            status: 'ENVIRONMENTAL_FEASIBILITY_PHASE_2',
            _count: 0,
          },
          {
            status: 'INFRASTRUCTURE',
            _count: 0,
          },
          {
            status: 'FOUNDATION',
            _count: 0,
          },
          {
            status: 'SKELETON_RISING',
            _count: 0,
          },
          {
            status: 'INTERIOR_WALLS',
            _count: 0,
          },
          {
            status: 'INSULATION',
            _count: 0,
          },
          {
            status: 'WALL_CLOSING',
            _count: 0,
          },
          {
            status: 'ELEVATOR',
            _count: 0,
          },
          {
            status: 'INTERIOR_FINISHING',
            _count: 0,
          },
          {
            status: 'FFE_INSTALL',
            _count: 0,
          },
          {
            status: 'PUNCH_OUT',
            _count: 0,
          },
          {
            status: 'QA_QC_WALKS',
            _count: 0,
          },
          {
            status: 'PENDING_INSPECTION_FIRE_MARSHALL',
            _count: 0,
          },
          {
            status: 'PENDING_INSPECTION_BUILDING_INSPECTOR',
            _count: 0,
          },
          {
            status: 'CERTIFICATE_OF_OCCUPANCY',
            _count: 0,
          },
          {
            status: 'MANAGEMENT_IN_PLACE',
            _count: 0,
          },
          {
            status: 'LEASE_UP',
            _count: 0,
          },
          {
            status: 'LEASED_STABILIZED',
            _count: 0,
          },
          {
            status: 'LENDER_CLOSE_OUT',
            _count: 0,
          },
          {
            status: 'WARRANTY_ITEMS',
            _count: 0,
          },
          {
            status: 'FOR_SALE',
            _count: 0,
          },
          {
            status: 'SOLD',
            _count: 0,
          },
          {
            status: 'OWNER_OCCUPIED',
            _count: 0,
          },
          {
            status: 'COMPLETED_INVENTORY',
            _count: 0,
          },
          {
            status: 'INIT',
            _count: 0,
          },
          {
            status: 'IN_PROGRESS',
            _count: 0,
          },
          {
            status: 'REVIEW',
            _count: 0,
          },
          {
            status: 'HOLD',
            _count: 0,
          },
          {
            status: 'COMPLETE',
            _count: 0,
          },
          {
            status: 'REBUILD_INVENTORY',
            _count: 0,
          },
          {
            status: 'REBUILD_RFP',
            _count: 0,
          },
          {
            status: 'DEVELOPER_AWARDED',
            _count: 0,
          },
          {
            status: 'DESIGN_BUILD',
            _count: 0,
          },
        ],
      },
      {
        slug: 'PROJECTS_BY_NEIGHBORHOOD',
        name: 'Projects By Neighborhood',
        description: 'Projects By Neighborhood',
        data: [
          {
            neighborhood: 'Downtown',
            _count: 3,
            totalDevelopmentCost: 22450000,
          },
          {
            neighborhood: 'Cold Spring Park',
            _count: 1,
            totalDevelopmentCost: 30000,
          },
          {
            neighborhood: 'Sherman Park',
            _count: 1,
            totalDevelopmentCost: 1000000,
          },
          {
            neighborhood: 'Wick Field',
            _count: 1,
            totalDevelopmentCost: 30000,
          },
        ],
      },
      {
        slug: 'PROJECT_BUDGET_SUMMARY',
        name: 'Project Budget Summary',
        description: 'Project Budget Summary',
        data: [
          {
            budget: [
              {
                name: 'CDBG Funds',
                amount: 2000000,
              },
              {
                name: 'Tax Credit Equity-NMTC',
                amount: 5000000,
              },
            ],
            id: 634,
            name: '4th & WI',
          },
          {
            budget: [
              {
                name: 'HOME Funds',
                amount: 30000,
              },
            ],
            id: 637,
            name: 'NIP-4212 Highland',
          },
          {
            budget: [
              {
                name: 'CDBG Funds',
                amount: 1000000,
              },
            ],
            id: 638,
            name: 'SFH',
          },
          {
            budget: [
              {
                name: 'Debt-Bank',
                amount: 300000,
              },
              {
                name: 'CDBG Funds',
                amount: 150000,
              },
            ],
            id: 652,
            name: 'New Project',
          },
          {
            budget: [
              {
                name: 'ARPA Funds',
                amount: 5000000,
              },
              {
                name: 'CDBG Funds',
                amount: 2000000,
              },
              {
                name: 'Tax Credit Equity-NMTC',
                amount: 8000000,
              },
            ],
            id: 635,
            name: 'Marcus Center Garage',
          },
          {
            budget: [
              {
                name: 'CDBG Funds',
                amount: 30000,
              },
            ],
            id: 636,
            name: 'NIP-384 Smith St',
          },
          {
            budget: [],
            id: 672,
            name: 'Test',
          },
        ],
      },
      {
        slug: 'PROJECTS_BY_CONSTRUCTION_TYPE',
        name: 'Projects By Construction Type',
        description: 'Projects By Construction Type',
        data: [
          {
            _count: 1,
            constructionType: 'Interior Fitout',
          },
          {
            _count: 2,
            constructionType: 'New Construction',
          },
          {
            _count: 4,
            constructionType: 'Renovation',
          },
        ],
      },
      {
        slug: 'PROJECTS_BY_PROJECT_TYPE',
        name: 'Projects By Project Type',
        description: 'Projects By Project Type',
        data: [
          {
            projectType: 'Mixed-Use',
            _count: 1,
            units: 500,
          },
          {
            projectType: 'Single Family',
            _count: 4,
            units: 0,
          },
          {
            projectType: 'Civic Facility',
            _count: 2,
            units: 0,
          },
        ],
      },
    ],
  };
}

export interface PostClientWidgetInterface {
  widgetId: number;
  accountId: number;
}
export async function postClientWidget(props: PostClientWidgetInterface) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/widgets/account`,
    data: props,
  });
  return res.data;
}

export async function deleteClientWidget(props: PostClientWidgetInterface) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.SHERPA}/widgets/account`,
    data: props,
  });
  return res.data;
}

export async function getClientWidgetsList(id?: number) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/widgets?accountId=${id}`,
  });
  return res.data;
}
